import classNames from 'classnames'
import React from 'react'

export type CardVariant = 'dark' | 'light'

export interface MediaShellProps {
  variant: CardVariant
  children: React.ReactNode
  rootRef?: React.Ref<HTMLDivElement>
  'data-testid'?: string
}

/**
 * Outer chrome for every LockedAttachment card.
 * Mirrors the 16px radius treatment from the Figma design system.
 */
const MediaShell: React.FC<MediaShellProps> = ({
  variant,
  children,
  rootRef,
  'data-testid': dataTestId,
}) => (
  <div
    ref={rootRef}
    data-testid={dataTestId}
    className={classNames(
      'relative w-[280px] select-none overflow-hidden rounded-md',
      variant === 'dark' ? 'bg-[#1e2330]' : 'bg-white',
      'shadow-[0_1px_2px_rgba(0,0,0,0.08)]'
    )}
  >
    {children}
  </div>
)

export default MediaShell
